module.exports = __webpack_public_path__ + "img/PetBtn.bb4a2e20.svg";